export const searchedElementDisplay = (item, search) => {
  return (
    !item?.mobile.includes(search) &&
    !item?.name?.toLowerCase().includes(search.toLowerCase()) &&
    search.length > 0
  );
};
